/* eslint-disable max-statements */
import prepareComponent from "@bluframe/grapple/prepareComponent";
import config from "config/site";
import useNewsCard from "hooks/news/useNewsCard";
import useCreateNewsCritics from "hooks/useCreateNewsCritics";
import useNewsCritics from "hooks/useNewsCritics";
import useUser from "hooks/useUser";
import { useMemo, useState } from "react";
import Edit from "./Edit";
const DEFAULT_IS_COMPACT = true;
const usePrepareComponent = () => {
    const { clear, setOverrides, state: { avNirvana, bluRay, hidefDigest, news, whySoBlu } } = useNewsCritics();
    const [isCompact, setIsCompact] = useState(DEFAULT_IS_COMPACT);
    const { isAdmin, isEditor } = useUser();
    const { areNewsSourcesLoading } = useCreateNewsCritics();
    const onClear = (serviceName) => () => {
        clear(serviceName);
    };
    const onSetOverrides = (serviceName) => (overrides) => {
        setOverrides(overrides, serviceName);
    };
    const isCompactCheckboxProps = {
        checked: isCompact,
        isDisabled: areNewsSourcesLoading,
        onChange: () => {
            setIsCompact(!isCompact);
        }
    };
    const newsControlCheckboxesProps = {
        isCompactCheckboxProps
    };
    /**
     *  List of news service names from config file.
     */
    const newsServiceNames = useMemo(() => Object.freeze(config.news
        .flatMap((item) => item.rows)
        .map((row) => ({ name: row.name, serviceName: row.serviceName }))), []);
    const newsCards = newsServiceNames.reduce((acc, { name, serviceName }) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        acc[serviceName] = useNewsCard({ name, serviceName });
        return acc;
    }, {});
    return {
        areNewsSourcesLoading,
        avNirvana: avNirvana.selected,
        bluRay: bluRay.selected,
        hidefDigest: hidefDigest.selected,
        isAdmin,
        isEditor,
        news,
        newsCards,
        newsControlCheckboxesProps,
        onClear,
        onSetOverrides,
        whySoBlu: whySoBlu.selected
    };
};
export default prepareComponent(usePrepareComponent)(Edit);
